// Get Lookbook
export const GET_LOOKBOOK_REQUEST = 'GET_LOOKBOOK_REQUEST';
export const GET_LOOKBOOK_DONE = 'GET_LOOKBOOK_DONE';
export const GET_LOOKBOOK_FAILED = 'GET_LOOKBOOK_FAILED';
